import { render } from "./RiLnbClose.vue?vue&type=template&id=3b00cb85"
import script from "./RiLnbClose.vue?vue&type=script&lang=js"
export * from "./RiLnbClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiLnbClose.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b00cb85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b00cb85', __exports__)) {
    api.reload('3b00cb85', __exports__)
  }
  
  module.hot.accept("./RiLnbClose.vue?vue&type=template&id=3b00cb85", () => {
    api.rerender('3b00cb85', render)
  })

}


export default __exports__